export default "__VITE_ASSET__00d3b409__"